/*
 * サブシステム名：入金
 * 機能名：入金取込
 */

import { mapGetters } from 'vuex'
import flowMixin from '@/mixins/flowMixins'

import filter from '@/rahmen/utils/filters'
import modals from '@/ddv2.library/modals'

import DdCustomButton from '@/components/DdCustomButton'
import DdTransparentButton from '@/components/DdTransparentButton'
import DdDialog from '@/views/DEP/D2COMD0120.vue'

const DdDropDown = () => import('@/components/DdDropDown')
const DdFileInput = () => import('@/components/DdFileInput')
const DdNarrowDownTextBox = () => import('@/components/DdNarrowDownTextBox')
const DdNumericBox = () => import('@/components/DdNumericBox')
const DdSelectItemsPerPage = () => import('@/components/DdSelectItemsPerPage')
const DdSubHeader = () => import('@/components/DdSubHeader')
const DdTextBox = () => import('@/components/DdTextBox')

// コードマスタ
const KBNSHURUICD_FORMAT_CD = 'KBN014'
const KBNSHURUICD_NYUKINTORIKOMI_KBN = 'KBN013'
const KBNSHURUICD_YOKINSHUMOKU = 'SFF070'
// 入金取込区分
const NYUKINTORIKOMIKBN_KAKUTEI = '1'
const NYUKINTORIKOMIKBN_MIKAKUTEI = '2'
const NYUKINTORIKOMIKBN_TAISHOGAI = '3'
// 取込ファイルタイプ
const FILETYPE = 'text/plain'
// 状況
const JOKYO_KAKUTEI = '確定'
const JOKYO_MIKAKUTEI = '未確定'

export default {
  name: 'NyukinTorikomiEdit',
  mixins: [flowMixin],
  components: {
    DdCustomButton,
    DdTransparentButton,
    DdDialog,
    DdDropDown,
    DdNarrowDownTextBox,
    DdNumericBox,
    DdFileInput,
    DdSelectItemsPerPage,
    DdSubHeader,
    DdTextBox
  },
  data: () => ({
    // ページネーション用
    itemsPerPage: 0,
    page: 1,

    isConditionHide: false,
    conditions: {
      fileFormatCd: '01',
      selectFile: '',
      dataFile: ''
    },
    rowCnt: 0,
    modeKengen: 1,
    modeOfEdit: 0,
    // ダイアログ用
    recData: {},
    readCheck: false,
    nyukinEditDialog: false
  }),
  computed: {
    ...mapGetters({
      viewTitle: 'system/viewTitle',
      helpUseFlg: 'DDMasters/helpUseFlg',
      kubunList: 'DDMasters/msysKubun',
      currentKaishaCode: 'users/currentKaishaCode'
    }),
    // 取込フォーマット
    nyukinTorikomiFormatList () {
      const list = this.kubunList.filter((elem) => elem.kbnShuruiCd === KBNSHURUICD_FORMAT_CD && elem.kaishaCd === this.currentKaishaCode)
        .map((elem) => {
          elem.value = elem.code.trim()
          elem.text = elem.codeNm.trim()
          return elem
        })
      return list
    },
    filteredRows () {
      this.rowCnt = 0
      if (Object.keys(this.rows).length !== 0) {
        // グリッド上ヘッダ部
        this.rows.nyukinGokeiKingakuDisp = this.rows.nyukinGokeiKingaku ? filter.numericFormatter(this.rows.nyukinGokeiKingaku) : 0
        this.rows.sakuseiWarekiYmdDisp = this.rows.sakuseiWarekiYmd ? this.warekiFormat(this.rows.sakuseiWarekiYmd) : ''
        this.rows.yokinShumokuNm = this.rows.yokinShumoku ? this.yokinShumokuNm(this.rows.yokinShumoku) : ''
        return this.rows.trNyukinTorikomiMeisaiList.map((meisai) => {
          meisai.jokyo = meisai.matchFlg ? JOKYO_KAKUTEI : JOKYO_MIKAKUTEI
          meisai.nyukinGokeiKingakuDisp = meisai.nyukinGokeiKingaku ? filter.numericFormatter(meisai.nyukinGokeiKingaku) : ''
          meisai.nyukinKingakuDisp = meisai.nyukinKingaku ? filter.numericFormatter(meisai.nyukinKingaku) : ''
          meisai.tatenKinkenKingakuDisp = meisai.tatenKinkenKingaku ? filter.numericFormatter(meisai.tatenKinkenKingaku) : ''
          meisai.kanjoWarekiYmdDisp = meisai.kanjoWarekiYmd ? this.warekiFormat(meisai.kanjoWarekiYmd) : ''
          meisai.kisanWarekiYmdDisp = meisai.kisanWarekiYmd ? this.warekiFormat(meisai.kisanWarekiYmd) : ''
          this.rowCnt += 1
          return meisai
        })
      }
    },
    // キャンセルボタン制御
    isCancelButtonDisplay () {
      if (this.modeKengen === 0 || this.modeOfEdit === 1) {
        return false
      }
      return true
    },
    // 保存ボタン制御
    isSaveButtonDisplay () {
      console.log('■', this.modeKengen, this.modeOfEdit)
      if (this.modeKengen !== 0 && this.modeOfEdit !== 1) {
        return true
      }
      return false
    },
    isSaveButtonDisabled () {
      return this.rowCnt === 0
    }
  },
  created () {
    this.id = this.$route.params.id
    if (this.id === '0') {
      this.id = 0
    }
  },
  mounted () {
    this.initialize()
  },
  methods: {
    getCloneTargetMethod: function () {
      return {
        rows: this.rows,
        conditions: this.conditions
      }
    },
    beforeRouteLeaveByMenu: function (next) {
      const opt = {
        nextCallback: next
      }
      this.preventTransition(opt)
    },
    initialize: function () {
      const self = this
      const opt = {
        loadMasters: ['msyskubun'],
        initializeInputPromise: function () {
          return new Promise((resolve) => {
            self.conditions.fileFormatCd = '01'
            self.conditions.selectFile = ''
            self.conditions.dataFile = ''
            resolve()
          })
        },
        savedInputRestorePromise: (c) => {
          return new Promise((resolve) => {
            // ユーザ保存項目の復元
            resolve()
          })
        },
        existsIdMethod: () => {
          return self.id !== 0
        },
        settingButtonStatePromise: (kengen) => {
          console.log('■settingButtonStatePromise1', kengen)
          return new Promise((resolve) => {
            console.log('■settingButtonStatePromise2', kengen)
            if (kengen.kengenKbn === '10') {
              // 読取モード
              self.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              self.modeKengen = 1
            } else {
              // フルアクセス
              self.modeKengen = 2
            }
            // thisId == 0 then 新規モード
            if (self.id === 0) {
              self.modeOfEdit = 0 // 新規モード
            } else if (this.modeKengen === 0) {
              self.modeOfEdit = 1 // 照会モード
            } else {
              self.modeOfEdit = 2 // 更新モード
            }

            self.$nextTick(() => {
              document.getElementById('heavy-element').style.display = ''
            })

            resolve()
          })
        },
        researchPromise: (c) => {
          console.log('NyukinTorikomiList.researchPromise', c)
          return new Promise(resolve => {
            self.conditions = c.cache.value.conditions || {}
            // 取込ボタン
            self.onTorikomiButtonClick().then(() => {
              resolve()
            })
          })
        },
        defineHeaderPromise: () => {
          // 取込明細一覧ヘッダー取得
          return new Promise(resolve => {
            self.headers = [
              { text: 'ID', value: 'id', align: ' d-none' },
              { text: '対象外', value: 'taishogai' },
              { text: '一致', value: 'matchFlgString', align: 'center' },
              { text: '入金先コード/名称', value: 'torihikisakiNm' },
              { text: 'No', value: 'nyukinTorikomiMeisaiNo' },
              { text: '振込依頼人コード', value: 'furikomiIraininCd' },
              { text: '振込依頼人名', value: 'furikomiIraininNm' },
              { text: '起算日', value: 'kisanWarekiYmdDisp' },
              { text: '入金額', value: 'nyukinKingakuDisp', align: 'end' },
              { text: 'うち他店金券類', value: 'tatenKinkenKingakuDisp', align: 'end' },
              { text: '照会番号', value: 'shokaiNo' },
              { text: '勘定日', value: 'kanjoWarekiYmdDisp' },
              { text: '仕向銀行名', value: 'shimukeGinkoNm' },
              { text: '仕向銀行店名', value: 'shimukeGinkoShitenNm' },
              { text: '取消区分', value: 'torikesihiKbn' },
              { text: 'EDI情報', value: 'ediInformation' }
            ]
            resolve()
          })
        }
      }
      this.initializeForViewer(opt)
    },
    // 入金データ一括作成
    onIkkatsuSaveBtn: function (e) {
      const self = this
      const opt = {
        registerRequestPromise: self.registerPromiseIkkatsu,
        registerResponsePromise: (data) => {
          return new Promise(resolve => {
            self.conditions.fileFormatCd = '01'
            self.conditions.selectFile = ''
            self.conditions.dataFile = ''
            this.rows = {}
            resolve()
          })
        },
        getIdMethod: () => {
          return self.id
        },
        continuousInputInitializePromise: (id) => {
          return new Promise(resolve => {
            // self.id = id
            // self.transition(1, { id: id }, self.initialize)
            this.Effects.loadComplete()
            resolve()
          })
        },
        getTransitionBackParams: function () {
          return {
            actionId: 0,
            param: { id: self.id }
          }
        },
        isUpdateModeMethod: function () {
          return self.id !== 0
        },
        isNoRefreshModeMethod: function () {
          return true
        }
      }
      // 入金データ一括作成ボタン押下時のみ実施
      // 不一致チェック
      var ImportNGDataCnt = 0
      var ImportDataCnt = 0
      var ImportDataAllCnt = 0
      self.rows.trNyukinTorikomiMeisaiList.filter(function (elem) {
        return elem
      }).map(function (elem) {
        // 不一致データ
        if (!elem.matchFlg) {
          ImportNGDataCnt += 1
        }
        // 対象外チェックON 一致不一致は見ない
        if (elem.taishogai) {
          ImportDataCnt += 1
        } else {
          // 対象外チェックOFF 不一致のみ
          if (!elem.matchFlg) {
            ImportDataCnt += 1
          }
        }
        ImportDataAllCnt += 1
        return elem
      })
      console.log('■カウンタ', ImportNGDataCnt, ImportDataCnt, ImportDataAllCnt)
      // 登録するデータが存在しない場合中断メッセージ
      if (ImportDataAllCnt === ImportDataCnt) {
        this.setInvalidSummaryMessage('COME0018')
        return false
      }
      // 一致以外が存在する場合警告メッセージ
      if (ImportNGDataCnt !== 0) {
        modals.showConfirm('DEPQ0001').then((ok) => {
          if (ok) {
            self.register(opt)
          }
        })
      } else {
        self.register(opt)
      }
    },
    // 一時保存
    onTmpSaveBtn: function (e) {
      const self = this
      const opt = {
        registerRequestPromise: self.registerPromise,
        registerResponsePromise: (data) => {
          return new Promise(resolve => {
            self.conditions.fileFormatCd = '01'
            self.conditions.selectFile = ''
            self.conditions.dataFile = ''
            this.rows = {}
            resolve()
          })
        },
        getIdMethod: () => {
          return self.id
        },
        continuousInputInitializePromise: (id) => {
          return new Promise(resolve => {
            // self.id = id
            // self.transition(1, { id: id }, self.initialize)
            this.Effects.loadComplete()
            resolve()
          })
        },
        getTransitionBackParams: function () {
          return {
            actionId: 0,
            param: { id: self.id }
          }
        },
        isUpdateModeMethod: function () {
          return self.id !== 0
        },
        isNoRefreshModeMethod: function () {
          return true
        }
      }
      self.register(opt)
    },
    // 入金取込区分を設定
    setNyukinTorikomiKbn: function (row, ikkatsu) {
      if (row.taishogai) {
        row.nyukinTorikomiKbn = NYUKINTORIKOMIKBN_TAISHOGAI
      } else {
        if (row.matchFlg && ikkatsu === true) {
          row.nyukinTorikomiKbn = NYUKINTORIKOMIKBN_KAKUTEI
        } else {
          row.nyukinTorikomiKbn = NYUKINTORIKOMIKBN_MIKAKUTEI
        }
      }
    },
    // 一時保存
    registerPromise: function () {
      var self = this
      // 対象外チェックON
      self.rows.trNyukinTorikomiMeisaiList.filter(function (elem) {
        return elem
      }).map(function (elem) {
        self.setNyukinTorikomiKbn(elem, false)
        return elem
      })
      var rowData = this.rows
      // 一時保存
      rowData.DepCreateFlg = false
      const f = this.HttpClient.put('/api/v1/TrNyukinTorikomiKihon/UpdateMultiFromNyukinTorikomi?id=0', rowData)
      return f
    },
    // 入金データ一括作成
    registerPromiseIkkatsu: function () {
      var self = this
      // 対象外チェック
      self.rows.trNyukinTorikomiMeisaiList.filter(function (elem) {
        return elem
      }).map(function (elem) {
        self.setNyukinTorikomiKbn(elem, true)
        return elem
      })
      var rowData = this.rows
      // 一括作成
      rowData.DepCreateFlg = true
      const f = this.HttpClient.put('/api/v1/TrNyukinTorikomiKihon/UpdateMultiFromNyukinTorikomi?id=0', rowData)
      return f
    },
    registerValidate: function () {
      return true
    },
    onCancelButtonClick: function (e) {
      const self = this
      const opt = {
        restoreInputsPromise: function (data) {
          return new Promise(resolve => {
            self.rows = data().rows
            self.conditions = data().conditions
            resolve()
          })
        }
      }
      this.cancelInputs(opt)
    },
    onNyukinEditDialogOpen: function (item) {
      this.readCheck = false
      console.log('■item', item)
      this.recData = item
      this.nyukinEditDialog = true
    },
    onNyukinEditDialogClosed: function (data) {
      this.nyukinEditDialog = false
      if (data === undefined) { return }
      // if (e.renkeiCheck) {
      //   this.setInvalidSummaryMessage('COMI0005')
      // }
      if (data.renkeiCheck) {
        console.log('★★★', data.messageCd)
        this.setInvalidSummaryMessage(data.messageCd)
        // 入金先マスタに口座を更新した場合、メッセージを表示
        // this.setInvalidSummaryMessage('DEPI0001')
      }
    },
    // 取込ボタン
    onTorikomiButtonClick: function (e) {
      this.clearSummaryMessage()
      const self = this
      const opt = {
        searchRequestPromise: function () {
          return new Promise(resolve => {
            self.HttpClient.post('/api/v1/TrNyukinTorikomiKihon/torikomi', self.conditions)
              .then((data) => {
                resolve(data)
              })
          })
        },
        searchResultMethod: function (data) {
          self.rows = data.payload
          const cache = {
            rows: self.rows,
            conditions: self.conditions
          }
          self.saveToChache(cache)
            .then(() => {
            })
        },
        getSavedInputMethod: function () {
          return {}
        }
      }
      self.rows = {}
      this.search(opt)
    },
    // ファイル選択
    onFilePicked: function (file) {
      if (file === undefined || file === null) {
        this.conditions.selectFile = ''
        return
      }
      // テキストファイル判断（MIMEタイプが'text/plain'でテキストファイルと判断）
      if (file.type.indexOf(FILETYPE) !== 0) {
        this.conditions.selectFile = ''
        return
      }
      const fr = new FileReader()
      fr.readAsDataURL(file)
      fr.addEventListener('load', () => {
        this.conditions.selectFile = fr.result
      })
    },
    // 和暦フォーマット変換
    warekiFormat: function (item) {
      return item.substring(0, 2) + '/' + item.substring(2, 4) + '/' + item.substring(4, 6)
    },
    // 入金取込区分名取得
    nyukinTorikomiKbnNm: function (item) {
      var nyukinTorikomiKbn = this.kubunList.find((elem) => {
        return elem.kbnShuruiCd === KBNSHURUICD_NYUKINTORIKOMI_KBN && elem.code.trim() === item.trim()
      })
      return nyukinTorikomiKbn.codeNm
    },
    // 口座種別
    yokinShumokuNm: function (item) {
      var yokinShumoku = this.kubunList.find((elem) => {
        return elem.kbnShuruiCd === KBNSHURUICD_YOKINSHUMOKU && elem.code.trim() === item.trim()
      })
      return yokinShumoku.codeNm
    },
    searchValidate: function () {
      return true
    },
    // ------------------------------------------------------------------------------------------
    // ページ操作
    // ------------------------------------------------------------------------------------------
    changeItemsPerPage: function (e) {
      console.log('changeItemsPerPage', e)
      this.itemsPerPage = e
      // 子コンポーネントへの反映
      this.$nextTick().then(() => {
        this.$refs.pagination1.syncPagination(this.itemsPerPage, this.page)
        this.$refs.pagination2.syncPagination(this.itemsPerPage, this.page)
      })
    },
    changePage: function (e) {
      this.page1 = e
      // 子コンポーネントへの反映
      this.$nextTick().then(() => {
        this.$refs.pagination1.syncPagination(this.itemsPerPage, this.page)
        this.$refs.pagination2.syncPagination(this.itemsPerPage, this.page)
      })
    },
    // ダミー
    onDummyFunction: function () {
      this.$emit('dummy')
    }
  }
}
